module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAD6SURBVHgB7ZnRDYMwDAXdTsAojNYNyGYdqSOkVOVJKA2JjUjsqD7JP0it74APBESO89/cqB2xx647DY4HaOMB2niANh6gDTfgsc5M/fjsCnQRgb6PBS+SRcRkuMzbrkgXRIREQhJxJmAvjwmlH9RuoXTxtM6T2txO8/bfE5UdxCz0ezY5V0JyBXJnPm67L+FMBDeguTyQRnACuskDSUQtoLs84EaUAtTkASfiKEBdHtQicgFm5EEpIj1uTh4cRXCOqcuDXERtzMgDSYQ5ecCJMCsPShHm5UEuYhh5sI8YTh4sNLC844xA6atJJFtkXf3VojbDBziO4+jyBk781u/zZwn9AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/web_mobile_top_icon.png
// module id = s1GR
// module chunks = 1